import React from 'react';
import { Reorder } from 'framer-motion';
import { GripVertical, Pencil, Trash2 } from 'lucide-react';
import { Badge } from '../../ui/badge';

export const QCItemRow = ({ item, onEdit, onDelete, onToggleRequired }) => (
  <Reorder.Item
    value={item}
    id={item.id}
    className="flex items-center gap-2 bg-white rounded-lg px-3 py-2.5 border border-zinc-200 shadow-sm group"
    whileDrag={{ scale: 1.02, boxShadow: '0 8px 20px rgba(0,0,0,0.12)' }}
  >
    <GripVertical className="h-4 w-4 text-zinc-300 cursor-grab active:cursor-grabbing flex-shrink-0" />
    <div className="flex-1 min-w-0">
      <p className="text-sm font-medium text-zinc-800 truncate">{item.label}</p>
    </div>
    <div className="flex items-center gap-2 flex-shrink-0">
      {item.is_required ? (
        <Badge
          className="bg-red-100 text-red-700 border-red-200 text-[10px] cursor-pointer hover:bg-red-200"
          onClick={() => onToggleRequired(item, false)}
        >
          Required
        </Badge>
      ) : (
        <Badge
          variant="outline"
          className="text-zinc-400 text-[10px] cursor-pointer hover:bg-zinc-100"
          onClick={() => onToggleRequired(item, true)}
        >
          Optional
        </Badge>
      )}
      <button
        onClick={() => onEdit(item)}
        className="p-1 rounded text-zinc-400 hover:text-[#F56F05] hover:bg-[#FFF7ED] transition-colors opacity-0 group-hover:opacity-100"
        data-testid={`edit-item-${item.id}`}
      >
        <Pencil className="h-3.5 w-3.5" />
      </button>
      <button
        onClick={() => onDelete(item)}
        className="p-1 rounded text-zinc-400 hover:text-red-500 hover:bg-red-50 transition-colors opacity-0 group-hover:opacity-100"
        data-testid={`delete-item-${item.id}`}
      >
        <Trash2 className="h-3.5 w-3.5" />
      </button>
    </div>
  </Reorder.Item>
);

export default QCItemRow;
